import { render, staticRenderFns } from "./TzzzImage.vue?vue&type=template&id=12ebbc4e&scoped=true"
import script from "./TzzzImage.vue?vue&type=script&lang=js"
export * from "./TzzzImage.vue?vue&type=script&lang=js"
import style0 from "./TzzzImage.vue?vue&type=style&index=0&id=12ebbc4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ebbc4e",
  null
  
)

export default component.exports